<div class="top-corner">
  <div style="float:left" class="input-group">
    <a class="navbar-item">
    </a>
  </div>
</div><br>
<div class="login-form">
  <form [formGroup]="recoverForm">
    <h4 class="text-center">{{title | translate}}</h4>
    <p class="text-center">{{ "MESSAGE.ENTER-THE-VERIFICATION-CODE-SENT-YOUR-EMAIL-ADDRESS" | translate }}</p>
    <div class="separator"></div>
    <div class="form-group mt-1">
      <input type="text"
             class="form-control"
             formControlName="verificationCode"
             [(ngModel)]="verificationCode"
             [class.is-invalid]="isInvalidControl('verificationCode')"
             (keyup.enter)="doIt()"
             placeholder="{{ 'LABEL.VERIFICATION-CODE' | translate }}"
             required="required">
      <small *ngIf="isInvalidControl('verificationCode')"
             class="text-danger">
        {{this.actualValue}}{{getErrorMessageBy('verificationCode')| translate}}
      </small>
    </div>
    <div class="separator"></div>
<!--    <div class="form-group text-right">-->
      <button type="button" class="btn btn-success w-100" (click)="doIt()">
        <i class="fa fa-check-circle"></i> {{ "BUTTON.VERIFY" | translate }}</button>
<!--    </div>-->
  </form>
</div>
<app-loading *ngIf="loading"></app-loading>
